/* Additive storefront controls. Shopify remains the authority for price and availability. */
(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('.tys-page,.tc-page').forEach(root => {
      if (root.dataset.tuReady) return;
      root.dataset.tuReady = 'true';
      const form = root.querySelector('.tys-buy-form');
      const inventory = root.querySelector('[data-tu-inventory]');
      const stock = root.querySelector('[data-tu-stock]');
      const stockData = inventory ? JSON.parse(inventory.textContent).variants : [];
      const refresh = () => {
        const id = form?.elements.namedItem('id')?.value;
        const variant = stockData.find(v => String(v.id) === String(id));
        if (stock) stock.textContent = !variant ? '' : !variant.available ? 'Deze uitvoering is uitverkocht.' : variant.limited ? `Nog ${variant.remaining} op voorraad van deze uitvoering.` : '';
        const mainBuy = root.querySelector('[data-main-buy]');
        const stickyBuy = root.querySelector('[data-tu-sticky-buy]');
        if (stickyBuy && mainBuy) { stickyBuy.disabled = mainBuy.disabled; stickyBuy.textContent = mainBuy.textContent; }

      };
      // Wait until the existing product handler has updated prices and disabled states.
      form?.addEventListener('change', () => queueMicrotask(refresh));
      form?.addEventListener('input', () => queueMicrotask(refresh));
      queueMicrotask(refresh);
      const controls = root.querySelector('[data-tu-collection-tools]');
      if (controls) {
        const cards = [...root.querySelectorAll('[data-tu-card]')];
        const grid = root.querySelector('.tc-products');
        const search = controls.querySelector('[data-tu-search]');
        const sort = controls.querySelector('[data-tu-sort]');
        const count = controls.querySelector('[data-tu-count]');
        const empty = root.querySelector('[data-tu-empty]');
        const update = () => {
          const query = search.value.trim().toLocaleLowerCase('nl-NL');
          const ordered = cards.map((card, index) => ({card,index}));
          ordered.sort((a,b) => {
            if (sort.value === 'title') return a.card.dataset.title.localeCompare(b.card.dataset.title,'nl');
            if (sort.value.startsWith('price-')) {
              const ap = a.card.dataset.price, bp = b.card.dataset.price;
              if (ap === '' || bp === '') return ap === bp ? a.index-b.index : ap === '' ? 1 : -1;
              return (Number(ap)-Number(bp)) * (sort.value === 'price-down' ? -1 : 1) || a.index-b.index;
            }
            return a.index-b.index;
          });
          let visible = 0;
          ordered.forEach(({card}) => {
            card.hidden = !card.textContent.toLocaleLowerCase('nl-NL').includes(query);
            if (!card.hidden) visible++;
            grid.append(card);
          });
          count.textContent = `${visible} van ${cards.length} producten in deze selectie`;
          empty.hidden = visible !== 0;
        };
        search.addEventListener('input',update);sort.addEventListener('change',update);
        const hasPrice = cards.some(card => card.dataset.price !== '');
        sort.querySelectorAll('option[value^="price-"]').forEach(option => { option.disabled = !hasPrice; });
        controls.hidden = false;update();
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

/* Native category anchors preserve reload/back behavior and land below the sticky header. */
(() => {
  const setup = () => {
    const header = document.querySelector('.te-header,.site-header');
    const overview = document.getElementById('TysCategoryOverview');
    const measure = () => {
      if (header) document.documentElement.style.setProperty('--tu-shop-header-height', header.getBoundingClientRect().height + 'px');
    };
    measure();
    if (header && typeof ResizeObserver !== 'undefined') new ResizeObserver(measure).observe(header);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    document.querySelectorAll('.tu-category-bar a,.tc-tabs a,.tc-card').forEach(link => {
      const url = new URL(link.href, location.href);
      if (preview && url.origin === location.origin) { url.searchParams.set('preview_theme_id', preview); link.href = url.href; }
    });
    if (overview && location.hash === '#TysCategoryOverview') {
      const land = () => { measure(); overview.scrollIntoView({block:'start',behavior:'instant'}); };
      // Run after images and fonts above the anchor have settled, only on initial navigation.
      if (document.readyState === 'complete') land();
      else window.addEventListener('load', land, {once:true});
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();
